import type { ImageType } from "~/components/common/images";
import Image from "~/components/common/images";

export interface GrowSectionProps {
  id: string;
  type: string;
  title: string;
  image?: ImageType;
  list: {
    text: string;
    id: string;
  }[];
}

const GrowSection = ({ type, title, list, image }: GrowSectionProps) => (
  <section
    id={type}
    className="section-padding-x bg-purple bg-gradient-to-b py-[50px] md:py-[120px]"
  >
    <div className="flex flex-col md:flex-row">
      <div className="w-full md:w-1/2">
        <div className="py-[35px] md:py-[100px] md:pr-[50px] 2xl:max-w-[60%]">
          <h2 className="h2 mb-[60px] text-left font-semibold text-white">
            {title}
          </h2>
          <ul className="flex flex-col gap-[30px]">
            {list.map((item) => (
              <li key={item.id} className="flex gap-[20px]">
                <div className="mt-[5px] size-[18px] shrink-0 text-white">
                  <svg
                    width="18"
                    height="19"
                    viewBox="0 0 18 19"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    className="size-full"
                  >
                    <path
                      d="M5.5 10.87L7.89167 12.8667C7.9559 12.9219 8.03111 12.9615 8.11184 12.9826C8.19256 13.0036 8.27677 13.0056 8.35833 12.9885C8.44068 12.9724 8.51873 12.9379 8.58718 12.8875C8.65563 12.8371 8.71287 12.7718 8.755 12.6963L12.5 6"
                      stroke="currentColor"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <rect
                      x="0.75"
                      y="1.25"
                      width="16.5"
                      height="16.5"
                      rx="8.25"
                      stroke="currentColor"
                      strokeWidth="1.5"
                    />
                  </svg>
                </div>
                <p className="font-medium text-white">{item.text}</p>
              </li>
            ))}
          </ul>
        </div>
      </div>
      <div className="mt-[50px] w-full shrink-0 md:mt-0 md:w-1/2">
        {image && (
          <Image
            image={image}
            className="md:h-full md:max-h-[590px]"
            alt={"Grow your business"}
          />
        )}
      </div>
    </div>
  </section>
);

export default GrowSection;
